module.exports = __webpack_public_path__ + "img/bobabu_bobocoin.gm.98cd532.png";